export const palette = {
    common: { black: "#000", white: "#fff" },
    primary: {
        lighter: "#2a8afb",
        light: "#0e5ebd",
        main: "#002653",
        dark: "#04172e",
        darker: "#040e1b",
        contrastText: "#fff",
    },
    secondary: {
        lighter: "#627f8c",
        light: "#42565f",
        main: "#222d32",
        dark: "#161c1f",
        darker: "#14191b",
        contrastText: "#fff",
    },
    info: {
        lighter: "#D0F2FF",
        light: "#74CAFF",
        main: "#1890FF",
        dark: "#0C53B7",
        darker: "#04297A",
        contrastText: "#fff",
    },
    success: {
        lighter: "#E9FCD4",
        light: "#AAF27F",
        main: "#54D62C",
        dark: "#229A16",
        darker: "#08660D",
        contrastText: "#212B36",
    },
    warning: {
        lighter: "#FFF7CD",
        light: "#FFE16A",
        main: "#FFC107",
        dark: "#B78103",
        darker: "#7A4F01",
        contrastText: "#212B36",
    },
    error: {
        lighter: "#FFE7D9",
        light: "#FFA48D",
        main: "#FF4842",
        dark: "#B72136",
        darker: "#7A0C2E",
        contrastText: "#fff",
    },
    grey: {
        "100": "#F9FAFB",
        "200": "#F4F6F8",
        "300": "#DFE3E8",
        "400": "#C4CDD5",
        "500": "#919EAB",
        "600": "#637381",
        "700": "#454F5B",
        "800": "#212B36",
        "900": "#161C24",
        "500_8": "rgba(145, 158, 171, 0.08)",
        "500_12": "rgba(145, 158, 171, 0.12)",
        "500_16": "rgba(145, 158, 171, 0.16)",
        "500_24": "rgba(145, 158, 171, 0.24)",
        "500_32": "rgba(145, 158, 171, 0.32)",
        "500_48": "rgba(145, 158, 171, 0.48)",
        "500_56": "rgba(145, 158, 171, 0.56)",
        "500_80": "rgba(145, 158, 171, 0.8)",
    },
    divider: "rgba(145, 158, 171, 0.24)",
    action: {
        active: "#637381",
        hover: "rgba(145, 158, 171, 0.08)",
        selected: "rgba(145, 158, 171, 0.16)",
        disabled: "rgba(145, 158, 171, 0.8)",
        disabledBackground: "rgba(145, 158, 171, 0.24)",
        focus: "rgba(145, 158, 171, 0.24)",
        hoverOpacity: 0.08,
        disabledOpacity: 0.48,
    },
    text: { primary: "#ffffff", secondary: "#212121", disabled: "#919EAB" },
    background: { paper: "#fff", default: "#fff", neutral: "#ccc" }
};
